import { render, staticRenderFns } from "./RenounceSavingRequested.vue?vue&type=template&id=2a806dac&"
import script from "./RenounceSavingRequested.vue?vue&type=script&lang=js&"
export * from "./RenounceSavingRequested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports